import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function AkamaiWAFConnectForm({ onSubmit, guideMode }) {
  const formInitialValues = {
    credentials: "",
  };
  const formCheckoutSchema = yup.object().shape({
    credentials: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="filled"
                name="credentials"
                label="Credentials"
                value={values.credentials}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.credentials && !!errors.credentials}
                helperText={touched.credentials && errors.credentials}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
